import React from "react";
import Chart from "react-apexcharts";
import { CriteriaScoreType } from "../../../types/TeacherEvaluation";

const CriteriaScoresTable = ({ data }: { data: CriteriaScoreType[] }) => {
  const criteriaAverage = data.reduce((acc, curr) => {
    acc[curr.criterio] = (acc[curr.criterio] || []).concat(curr.score);
    return acc;
  }, {} as Record<string, number[]>);

  const averageScores = Object.entries(criteriaAverage).map(([criterio, scores]) => ({
    criterio,
    average: parseFloat((scores.reduce((sum, score) => sum + score, 0) / scores.length).toFixed(2)), // Média com 2 casas decimais
  }));

  const barChartData = {
    series: [
      {
        name: "Média",
        data: averageScores.map((item) => item.average),
      },
    ],
    options: {
      chart: { type: "bar" as const },
      xaxis: { categories: averageScores.map((item) => item.criterio) },
      title: { text: "Média das Pontuações por Critério (Barra)" },
    },
  };

  const pieChartData = {
    series: averageScores.map((item) => item.average),
    options: {
      chart: { type: "pie" as const },
      labels: averageScores.map((item) => item.criterio),
      title: { text: "Média das Pontuações por Critério (Pizza)" },
      tooltip: {
        y: {
          formatter: (value: number) => value.toFixed(2), // Formata o tooltip com 2 casas decimais
        },
      },
      dataLabels: {
        formatter: (value: number) => value.toFixed(2), // Formata os labels com 2 casas decimais
      },
    },
  };

  return (
    <div>
      <h3>Pontuações por Critérios</h3>

      {/* Gráfico de Barras */}
      <div style={{ marginTop: "20px" }}>
        <h4>Gráfico de Barras</h4>
        <Chart options={barChartData.options} series={barChartData.series} type="bar" height={350} />
      </div>

      {/* Gráfico de Pizza */}
      <div style={{ marginTop: "20px" }}>
        <h4>Gráfico de Pizza</h4>
        <Chart options={pieChartData.options} series={pieChartData.series} type="pie" height={350} />
      </div>
    </div>
  );
};

export default CriteriaScoresTable;
